export default "__VITE_ASSET__aecf52d1__"